import { useState, useEffect } from 'react';
import { useMiningStore } from '../../../Store/miningStore';

export const BOOST_COOLDOWN = 180; // ~30 минут

export const useBoostTimer = () => {
  const [isBoostAvailable, setIsBoostAvailable] = useState(true);
  const [remainingTime, setRemainingTime] = useState('0:00');
  
  // Получаем данные из стора
  const lastBoostTime = useMiningStore((state) => state.lastBoostTime);
  const miningData = useMiningStore((state) => state.miningData);

  useEffect(() => {
    console.log('Mining data from store:', {
      miningData,
      lastBoostTime: miningData?.last_boost_time || lastBoostTime
    });

    const checkBoostState = () => {
      // Используем last_boost_time из miningData, если lastBoostTime не определен
      const boostTime = miningData?.last_boost_time || lastBoostTime;

      if (!boostTime) {
        console.log('No boost time available yet');
        return;
      }

      // Получаем время в UTC
      const lastBoostUTC = new Date(boostTime + 'Z');
      const currentUTC = new Date();
      
      // Разница в секундах
      const diffInSeconds = Math.floor((currentUTC.getTime() - lastBoostUTC.getTime()) / 1000);

      // console.log('Timer calculation:', {
      //   boostTime,
      //   lastBoostUTC: lastBoostUTC.toISOString(),
      //   currentUTC: currentUTC.toISOString(),
      //   diffInSeconds,
      //   BOOST_COOLDOWN
      // });

      // Если прошло меньше времени чем кулдаун
      if (diffInSeconds < BOOST_COOLDOWN) {
        const timeLeft = BOOST_COOLDOWN - diffInSeconds;
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        
        const timeString = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        
        // console.log('Setting timer:', timeString);
        
        setIsBoostAvailable(false);
        setRemainingTime(timeString);
      } else {
        // console.log('Boost is available');
        setIsBoostAvailable(true);
        setRemainingTime('0:00');
      }
    };

    // Проверяем сразу при получении данных
    checkBoostState();

    // И каждую секунду
    const intervalId = setInterval(checkBoostState, 1000);
    return () => clearInterval(intervalId);
  }, [lastBoostTime, miningData]);

  // Логируем изменения состояния
 

  return { 
    isBoostAvailable, 
    remainingTime,
    lastBoostTime: miningData?.last_boost_time || lastBoostTime 
  };
};
